import MuiValidTextField from 'src/components/input/MuiValidTextField';

const WholeNumberInput = ({ inputProps, ...props }) => {
  // Validation function to check if input is an integer
  const validateInteger = (value) => {
    if (!Number.isInteger(Number(value))) {
      return 'Please enter a whole number';
    }
    return undefined;
  };

  const newInputProps = {
    ...inputProps,
    onKeyPress: (event) => {
      if (event.key === '.') {
        event.preventDefault();
      }
    },
    onPaste: (event) => {
      const pastedText = event.clipboardData.getData('text');
      if (pastedText.includes('.')) {
        event.preventDefault();
      }
    },
  };

  return <MuiValidTextField inputProps={newInputProps} validate={validateInteger} {...props} />;
};

export default WholeNumberInput;
